// frontend/src/components/ArtTags/ArtTagCard.js
import React from "react";
import "./ArtTagCard.css";

const ArtTagCard = ({ artTag, onClick }) => {
  return (
    <div onClick={onClick} className="arttag-card">
      <div className="arttag-card-image-container">
        <img
          src={artTag.image}
          alt={artTag.name}
          className="arttag-card-image"
        />
      </div>
      <div className="arttag-card-overlay">
        <h2 className="arttag-card-title">{artTag.name}</h2>
      </div>
    </div>
  );
};

export default ArtTagCard;
